import type {
  BarometerSuccess,
} from '@autobid/strapi-integration/typescript/auction/barometerCar'
import type { AuctionPauseEvent } from '@autobid/ui/types/websocket/AuctionPauseEvent'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import {
  getBarometerQueryKey,
} from '@autobid/ui/composables/car/data/useBarometerCar'
import { BAROMETER_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useBarometerSocket'
import { updateNonStaleQueries } from '@autobid/ui/utils/updateNonStaleQueries'
import { useQueryClient } from '@tanstack/vue-query'

export function useBarometerAuctionPause() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const auctionPause = () => {
    const callback = (
      event: AuctionPauseEvent,
      queryKey: ReturnType<typeof getBarometerQueryKey>,
    ) => {
      const { auctionId } = event.context

      updateNonStaleQueries(queryClient, queryKey, (item?: BarometerSuccess['data']['singleItem']) => {
        if (!item)
          return item

        if (item.item.itemData.auctionId !== auctionId)
          return item

        if (item.item.itemData.stage !== 'IN_AUCTION')
          return item

        return {
          ...item,
          item: {
            ...item.item,
            itemData: {
              ...item.item.itemData,
              pausedHotbidStartTime: item.item.itemData.hotbidStartTime,
              hotbidStartTime: null,
            },
          },
        }
      })
    }

    startListen({
      eventName: 'premium.AUCTION_PAUSE',
      callbackName: BAROMETER_SOCKET_CALLBACK,
      callback: (event) => {
        const currentCarKey = getBarometerQueryKey({
          type: 'current',
          auctionId: event.context.auctionId,
        })
        const barometersKey = getBarometerQueryKey({ type: 'item' })

        callback(event, currentCarKey)
        callback(event, barometersKey)
      },
    })
  }

  return { auctionPause }
}
